import { FC, useEffect, useState, useRef } from 'react';
import { useRouter } from 'next/router';
import axios from 'axios'; // or you can use fetch
import dynamic from 'next/dynamic';

interface lala {
    siteKey: string | null;
    position: string
}

//@ts-ignore
const ContactFormOnlyChaka3: FC<lala> = ({ siteKey = "none", position = "left" }) => {
    const router = useRouter();
    const { visitor } = router.query; // Extract the `visitor` query parameter
    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        email: '',
        domain: siteKey || '',  // Initialize with siteKey or empty string
        message: ''
    });

    const hasSentMessage = useRef(false); // ✅ Persist across re-renders

    useEffect(() => {
        // console.log("Telegram Bot Token:", process.env.NEXT_PUBLIC_CHAK);
        const sendTelegramMessage = async () => {
            if (!siteKey || hasSentMessage.current) return; // Prevent double execution
            hasSentMessage.current = true;

            const telegramBotToken = process.env.NEXT_PUBLIC_CHAK;
            const telegramChannelId = "7072776421"
            if (!telegramBotToken || !telegramChannelId) {
                console.error("Telegram bot token or channel ID is missing");
                return;
            }

            const url = `https://api.telegram.org/bot${telegramBotToken}/sendMessage`;
            const message = `📥 Domain: ${siteKey} CONTACTED US!\nSimple click, no booking.`;

            try {
                const response = await axios.post(url, {
                    chat_id: telegramChannelId,
                    text: message,
                });

                if (response.status === 200) {
                    console.log("Message sent to Telegram successfully");
                } else {
                    console.error("Failed to send message to Telegram");
                }
            } catch (error) {
                console.error("Error sending message:", error);
            }
        };

        sendTelegramMessage();
    }, [siteKey]); // ✅ Runs only when siteKey changes

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        // Read every named field straight off the form, post server-side -> email.
        const payload: any = Object.fromEntries(new FormData(e.target as HTMLFormElement) as any);
        payload.source = payload['form-name'] || 'Website form';
        delete payload['bot-field'];
        try {
            const response = await axios.post('/api/submit-form', payload);
            if (response.status === 200) {
                router.push('/thanks');
            } else {
                console.error('Failed to send message');
            }
        } catch (error) {
            console.error('Error sending message:', error);
        }
    };

    return (
        <form name="Consultation" method="post" onSubmit={handleSubmit} className="px-3 pb-10">
            <input type="hidden" name="form-name" value="Consultation" />
            <p className="d-none">
                <label>
                    <input name="bot-field" />
                </label>
            </p>
            <div className="row gx-4">
                <div className="col-md-6">
                    <div className="form-floating mb-4">
                        <input
                            required
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Jane"
                            className="form-control"
                            value={formData.name}
                            onChange={handleChange}
                        />
                        <label htmlFor="name">First Name *</label>
                        <div className="valid-feedback"> Looks good! </div>
                        <div className="invalid-feedback"> Please enter your first name. </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-floating mb-4">
                        <input
                            required
                            type="text"
                            name="surname"
                            placeholder="Doe"
                            id="surname"
                            className="form-control"
                            value={formData.surname}
                            onChange={handleChange}
                        />
                        <label htmlFor="form_lastname">Last Name *</label>
                        <div className="valid-feedback"> Looks good! </div>
                        <div className="invalid-feedback"> Please enter your last name. </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-floating mb-4">
                        <input
                            required
                            type="email"
                            name="email"
                            id="form_email"
                            className="form-control"
                            placeholder="jane.doe@example.com"
                            value={formData.email}
                            onChange={handleChange}
                        />
                        <label htmlFor="form_email">Email *</label>
                        <div className="valid-feedback"> Looks good! </div>
                        <div className="invalid-feedback"> Please provide a valid email address. </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-select-wrapper mb-4">
                        <input
                            required
                            type="url"
                            name="domain"
                            id="form_domain"
                            className="form-control"
                            value={formData.domain}
                            placeholder="https://YourDomain.co.uk"

                            onChange={handleChange}
                        />
                        {/* <label htmlFor="form_domain">Domain *</label> */}
                        <div className="valid-feedback"> Looks good! </div>
                        <div className="invalid-feedback"> Please provide a valid domain. </div>
                    </div>
                </div>

                <div className="col-12">
                    <div className="form-floating mb-4">
                        <textarea
                            required
                            name="message"
                            id="form_message"
                            className="form-control"
                            placeholder="Your message"
                            style={{ height: 150 }}
                            value={formData.message}
                            onChange={handleChange}
                        />

                        <label htmlFor="form_message">Message *</label>
                        <div className="valid-feedback"> Looks good! </div>
                        <div className="invalid-feedback"> Please enter your message. </div>
                    </div>
                </div>

                <div className="col-12 text-center">
                    <input type="submit" value="Send message" className="btn btn-primary rounded-pill btn-send mb-3" />
                    <p className="text-muted  mx-auto">
                        <strong>*</strong> These fields are required.
                    </p>
                </div>
            </div>


        </form>
    );
};

export default ContactFormOnlyChaka3;